import request from '@/Network/Requests/request'
import Service from '@/Network/Services/Service'
import { CreateNpsForm, UpdateNpsForm, FiltersNpsForms } from '@/Network/Types/Requests/NpsRequests'
import { NpsFormResponse, ListNpsFormsResponse } from '@/Network/Types/Responses/NpsResponses'

export default class NpsFormService extends Service {
  prefix: string

  constructor() {
    super()
    this.prefix = '/nps/forms'
  }

  async create(payload: CreateNpsForm): Promise<NpsFormResponse> {
    const response = await request.post<NpsFormResponse>(this.getCompletePath(), payload)
    return response.data
  }

  async update(formId: number, payload: UpdateNpsForm): Promise<NpsFormResponse> {
    const response = await request.put<NpsFormResponse>(
      `${this.getCompletePath()}/${formId}`,
      payload
    )
    return response.data
  }

  async getById(formId: number): Promise<NpsFormResponse> {
    const response = await request.get<NpsFormResponse>(`${this.getCompletePath()}/${formId}`)
    return response.data
  }

  async toggleActive(formId: number, companyId: number): Promise<NpsFormResponse> {
    const response = await request.patch(
      `${this.getCompletePath()}/${formId}/toggle-active?companyId=${companyId}`,
      {}
    )
    return response.data as NpsFormResponse
  }

  async delete(formId: number): Promise<void> {
    await request.delete(`${this.getCompletePath()}/${formId}`)
  }

  async list(filters?: FiltersNpsForms): Promise<ListNpsFormsResponse> {
    try {
      const { data } = await request.get<ListNpsFormsResponse>(this.getCompletePath(), filters)
      return data
    } catch (e) {
      return {
        count: 0,
        data: []
      }
    }
  }
}
